import { Component,Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageConverterPipe } from '../../pipes/image-converter.pipe'; 

@Component({
  selector: 'app-section-banner',
  standalone: true,
  imports: [CommonModule,ImageConverterPipe],
  templateUrl: './section-banner.component.html',
  styleUrl: './section-banner.component.scss'
})
export class SectionBannerComponent {
  @Input() title: string = 'Nosotros'; 
  @Input() backgroundImage: string = 'assets/img/banner_about.png';
}
